import BrokerOne from './1.png'
import BrokerTwo from './2.png'
import BrokerThree from './3.png'
import BrokerFor from './4.png'
import BrokerFive from './5.png'
import BrokerSix from './6.png'
import BrokerSeven from './7.png'

export const brokerIcons = { BrokerSeven, BrokerFive, BrokerFor, BrokerOne, BrokerThree, BrokerSix, BrokerTwo }